import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ErroredElementViewModel } from "./erroredElement-viewModel";

export class CompactView extends View<ErroredElementViewModel>{
    GetViewUniqueId(): string {
        return "V-50869B24-7C9F-4BE8-B5A6-307D3991CC24"
    }
    loadHtml(): string {
        let element = require('./compact.html').default;
        let style = require('./compact.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
    public set IsElementHasError(v: boolean) { this._IsElementHasError = v; } public get IsElementHasError(): boolean { return this._IsElementHasError;} private _IsElementHasError: boolean;

}
